import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const outerRef = useRef(null);
  const dotRef = useRef(null);
  const target = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // enable only on non-touch, wide viewports
    const isCoarse = window.matchMedia("(hover: none)").matches;
    const narrow = window.innerWidth < 1024;
    if (isCoarse || narrow) return;
    setEnabled(true);
    document.body.classList.add("cursor-hidden");

    const onMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      }
    };

    const hoverables = "a, button, input, textarea, select, [data-cursor='hover']";
    const onOver = (e) => {
      if (e.target.closest && e.target.closest(hoverables)) {
        outerRef.current?.classList.add("is-hover");
      }
    };
    const onOut = (e) => {
      if (e.target.closest && e.target.closest(hoverables)) {
        outerRef.current?.classList.remove("is-hover");
      }
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);

    let raf;
    const loop = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.18;
      pos.current.y += (target.current.y - pos.current.y) * 0.18;
      if (outerRef.current) {
        outerRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
      cancelAnimationFrame(raf);
      document.body.classList.remove("cursor-hidden");
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={outerRef} className="custom-cursor" data-testid="custom-cursor-outer" />
      <div ref={dotRef} className="custom-cursor-dot" data-testid="custom-cursor-dot" />
    </>
  );
}
